import {
  BREAKPOINT_LARGE
} from '../config/breakpoints';

export default function(breakpoint = BREAKPOINT_LARGE) {
  let media = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);

  if (media.matches) {
    return true;
  }
  else {
    return false;
  }
}
